import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/cn';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'flat' | 'inset';
  accentLeft?: boolean;
  children: ReactNode;
}

export function Card({ variant = 'default', accentLeft, className, children, ...rest }: CardProps) {
  return (
    <div
      className={cn(
        'card',
        variant === 'flat' && 'card-flat',
        variant === 'inset' && 'card-inset',
        accentLeft && 'card-accent-left',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
